module.exports = __webpack_public_path__ + "img/nous.6f2e834a.png";